import { render, staticRenderFns } from "./ConfigurationSSL.vue?vue&type=template&id=007864ac&scoped=true&"
import script from "./ConfigurationSSL.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSSL.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationSSL.vue?vue&type=style&index=0&id=007864ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007864ac",
  null
  
)

export default component.exports